import { Response } from '@custom-types/Response';
import { UserSession } from '@custom-types/UserSession';
import apiFn from '@services/api-service';

const api = (action: string) => apiFn(`/api/uapi/onsite-app/${action}`);

const identityApi = (endpoint: string) => apiFn(`/api/uapi/identity/${endpoint}`);
const FORGOT_PASSWORD_TYPE = 'onsite_app';
export const SUPPORT_EMAIL = 'support@eventmobi.com';

export const loginWithPassword = (email: string, password: string) =>
  api('login')
    .post('', { email, password })
    .then((response: Response<UserSession>) => response.data.data);

export const loginWithAccessCode = (email: string, accessCode: string) =>
  api('login')
    .post('access-code', { email, accessCode })
    .then((response: Response<UserSession>) => response.data.data);

export const logout = () =>
  api('logout')
    .post('')
    .then(response => response.data.data);

export const sendForgotPasswordEmail = (payload = {}) =>
  identityApi('forgot-password').post('', { ...payload, type: FORGOT_PASSWORD_TYPE });

export const getLoginStatus = () =>
  api('login')
    .get('status')
    .then((response: Response<UserSession>) => response.data.data);
